/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { Constants } from '../constants';
import { Log } from '../logging/Log';

export class RecoveryMechanism {
    private static TAG: string = 'RecoveryMechanism';

    private static serviceInRecoverySet: Set<string> = new Set();

    static async callServiceWithRecovery<ResponseType>(
        serviceFunction: Function,
        serviceFunctionParameters: Array<any>,
        recoveryDelayTime?: number,
    ): Promise<ResponseType> {
        const recoveryDelay = recoveryDelayTime || Constants.DEFAULT_RECOVERY_DELAY;
        if (!this.serviceInRecoverySet.has(`${serviceFunction}`)) {
            let attempts = 0;
            return new Promise((resolve) => {
                const recoverService = () => {
                    this.serviceInRecoverySet.add(`${serviceFunction}`);
                    return serviceFunction(...serviceFunctionParameters)
                        .then((res) => {
                            this.serviceInRecoverySet.delete(`${serviceFunction}`);
                            return resolve(res);
                        })
                        .catch((error: any) => {
                            Diagnostics.debug(
                                this.TAG,
                                `attempt: ${attempts} delay: ${recoveryDelay}`,
                                error,
                            );
                            Log.d(this.TAG, `attempt: ${attempts} delay: ${recoveryDelay}`, error);
                            setTimeout(() => {
                                attempts += 1;
                                return recoverService();
                            }, recoveryDelay);
                        });
                };
                return setTimeout(() => {
                    attempts += 1;
                    return recoverService();
                }, recoveryDelay);
            });
        }
        throw new Error(`${serviceFunction} already in recovery`);
    }
}
